/**
 * The saved UI language, read when each partner's assets module loads.
 *
 * Deliberately imports nothing. The asset modules used to go through
 * utils/commonFunctions, which imports `partners` back; whenever a module that
 * reaches commonFunctions loaded before `partners`, the asset module ran while
 * commonFunctions was half-initialised and threw "Cannot access
 * 'getLocalStorageItem' before initialization" at startup. Storage can also
 * throw (blocked site data), which must not break module load either.
 */
export const storedLocale = (): string | null => {
  try {
    return localStorage.getItem('i18nextLng');
  } catch {
    return null;
  }
};
